import Axios from 'axios';
import config from '../constants/config';

const ApiService = (url = config.api_url)  => Axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default ApiService;
